module.exports = __webpack_public_path__ + "static/media/companyLogo.4f2827d5.png";